// extracted by mini-css-extract-plugin
export default {"productGallery":"MI-z","inQuickShop":"NI-z"};